export default "__VITE_ASSET__BvUfRQh6__"